"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const CreativeVideo = () => /*#__PURE__*/_react.default.createElement("svg", {
  viewBox: "0 0 24 16",
  xmlns: "http://www.w3.org/2000/svg",
  "data-icon": "cretiveVideo"
}, /*#__PURE__*/_react.default.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/_react.default.createElement("g", {
  id: "CreativeVideo"
}, /*#__PURE__*/_react.default.createElement("g", {
  id: "Group"
}, /*#__PURE__*/_react.default.createElement("g", {
  id: "video"
}, /*#__PURE__*/_react.default.createElement("path", {
  d: "M21.9,14.425 L17.3333333,11.2791667 L17.3333333,4.72083333 L21.9,1.57083333 C22.7875,0.9625 24,1.5875 24,2.64583333 L24,13.35 C24,14.4125 22.7833333,15.0333333 21.9,14.425 Z",
  id: "Path",
  fill: "#459CA6"
}), /*#__PURE__*/_react.default.createElement("path", {
  d: "M0,14.0083333 L0,1.99166667 C0,0.89169954 0.89169954,0 1.99166667,0 L14.0083333,0 C14.5365562,0 15.0431444,0.209835707 15.4166543,0.583345661 C15.7901643,0.956855615 16,1.46344382 16,1.99166667 L16,14.0083333 C16,15.1083005 15.1083005,16 14.0083333,16 L1.99166667,16 C1.46344382,16 0.956855615,15.7901643 0.583345661,15.4166543 C0.209835707,15.0431444 0,14.5365562 0,14.0083333 Z",
  id: "Path",
  fill: "#5BC8D5"
}))))));

var _default = CreativeVideo;
exports.default = _default;